// React Hooks
import { useCallback, useEffect, useRef, useState } from "react";
// CSS
import "./sites.css";
// Localisation
import { useTranslation } from "react-i18next";
// components for common panel
import CommonPanel from "../../common/common-panel";
import AllSitesTable from "./components/all-sites-table";

// Services
import OperationService from "../../../services/AuraCamera/operations.service";
import SitesService from "../../../services/AuraCamera/sites/sites.service";

// Loading Screen
import LoadingScreen from "../../common/Loading";
import PersistantService from "../../../services/autentication/persistant.service";
// Primefaces
import { Toast } from "primereact/toast";
import { ConfirmDialog } from "primereact/confirmdialog";
// Export Table
import * as XLSX from "xlsx";

// redux store
import { ReducerTableData } from "../../../store/AuraCamera/sites/sites.store";
import { AppDispatch, AppState } from "../../../store/store";
import { useDispatch, useSelector } from "react-redux";

// Helper
import Helpers from "../../../utils/helpers";

interface Active {
  gridActive?: string;
  tableActive?: string;
}

const Sites = () => {
  document.title = "Sites";
  const session = window.localStorage;
  const { t } = useTranslation();
  const toast = useRef<any>(null);
  const [FilterSizeSelectedVal, setFilterSizeSelectedVal] = useState<any>([]);
  const dispatch: AppDispatch = useDispatch();
  var ReduxOperationTableData: any = useSelector(
    (state: AppState) => state.Operations.operationTableData
  );


  let customer =
    PersistantService.getPersistSelectedCustomer()?.dashboardSelectedCustomer;

  const [isLoading, isLoadingUpdate] = useState(false);
  const [loadingText, loadingTextUpdate] = useState("");
  const [getLDRStatus, setLDRStatus] = useState("");
  const [SitesTableValues, setSitesTableValues] = useState<any>([]);

  const [isGrid, layoutToggle] = useState(false);
  const [activeClass, setActiveClass] = useState<Active>({
    gridActive: "",
    tableActive: "icon-active",
  });

  // for success toast.
  const showToast = (
    severityValue: any,
    summaryValue: any,
    detailValue: any
  ) => {
    toast?.current?.clear();
    toast?.current?.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  useEffect(() => {
    if (session.getItem("setSiteUpdateToastFlag") == "true") {
      session.setItem("setSiteUpdateToastFlag", "false");

      showToast("success", "Site Updated", "Site Updated successfully.");
    }

    if (session.getItem("setSiteCreateToastFlag") == "true") {
      session.setItem("setSiteCreateToastFlag", "false");

      showToast("success", "Site Created", "Site Created successfully.");
    }


  }, []);

  const SiteTableAPIInfo = useCallback(async () => {
    isLoadingUpdate(true);

    const response: any = await SitesService.SitesTableApiData();
    if (response == "error") {
      toast?.current?.clear();
      toast?.current?.show({
        severity: "error",
        summary: "Something went wrong",
        detail: "Unable to fetech data, Please try again",
        life: 3000,
      });

      isLoadingUpdate(false);
    } else {
      if (response && response.length > 0) {
        setSitesTableValues(response);
        isLoadingUpdate(false);
      }
      isLoadingUpdate(false);
    }

  }, []);

  useEffect(() => {
    SiteTableAPIInfo();
  }, [SiteTableAPIInfo]);

  function convert(str: any) {
    var date = new Date(str);

    return [date.getFullYear()].join("-");
  }

  const handleDownload = () => {
    let SitesTableValuesDeepCopy = JSON.parse(JSON.stringify(SitesTableValues));
    if (SitesTableValuesDeepCopy?.length > 0) {
      SitesTableValuesDeepCopy?.map((val: any, i: any) => {
        if (val.createdOn != null) {
          val.finalCreatedOn = Helpers.ConvertUtcToLocalReadable(val.createdOn);
        } else {
          val.finalCreatedOn = "";
        }
      });

      SitesTableValuesDeepCopy?.map((val: any, i: any) => {
        if (val.status == "true") {
          val.finalStatus = "Active";
        } else {
          val.finalStatus = "Inactive";
        }
      });

      SitesTableValuesDeepCopy?.map((val: any, i: any) => {
        val.Location = val.city + "," + val.state + "," + val.zip;
      });

      Helpers.exportToCSV(
        SitesTableValuesDeepCopy,
        "Sites_Summary",
        "Sites_Summary",
        {
          siteName: "Site name",
          companyName: getLDRStatus,
          Location: "Location",
          contactName: "Site Contact Name",
          phone: "Phone Number",
          notes: "Notes",
          finalStatus: "Status",
        },
        [
          "siteName",

          "companyName",
          "Location",
          "contactName",
          "phone",
          "notes",
          "finalStatus",
        ]
      );
    }
  };

  const handleLayout = (childvalue: any) => {
    layoutToggle(childvalue);
    if (childvalue === true) {
      setActiveClass({
        gridActive: "icon-active",
        tableActive: "",
      });
    } else {
      setActiveClass({
        gridActive: "",
        tableActive: "icon-active",
      });
    }
  };

  return (
    <>
      <LoadingScreen isLoading={isLoading} />
      <Toast ref={toast} style={{ marginTop: "25px", zIndex: 9999 }} />
      {/* <LoadingScreen isLoading={isLoading} text={loadingText} /> */}
      <ConfirmDialog />
      <nav aria-label="breadcrumb" className="breadcrumb--wrapper">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>{t("SitesText")}</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            <a>{t("SitesSummary.PageHeading")}</a>
          </li>
        </ol>
      </nav>
      <div className="content__header">
        <div className="content__wrap">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <h4 className="page-heading">{t("SitesSummary.PageHeading")}</h4>
            </div>
          </div>
        </div>
      </div>

      <div className="content__boxed dashboard_aogi_content_box_first">
        <div className="content__wrap">
          <div className="dashboard_main_div">
            <div className="card all-surveys-table card-mt">
              <CommonPanel
                tableData={handleLayout}
                gridData={handleLayout}
                activeClass={activeClass}
                downloadData={handleDownload}
                InnerComponent={
                  <AllSitesTable
                    isGrid={isGrid}
                    setLDRStatus={setLDRStatus}
                    filteredValues={SitesTableValues}
                    filterBySize={FilterSizeSelectedVal}
                  />
                }
                Heading={`${t("SitesSummary.AllSitesHeading")}`}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sites;
